<!-- html富文本消息，对应webim的 5-5 -->
<template>
  <div>
    <div class="richmsg-type-5">
      <div v-html="msgContent"></div>
    </div>
  </div>
</template>

<script>
import robotMsgFilter from '@/utils/robotMsgFilter';
import Utils from '@/utils/string';

export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const msgData = this.message.content;
    const msgContent = Utils.coverEmojIndex2EmojiImg(robotMsgFilter(msgData.content || ''));
    return {
      msgData,
      msgContent,
    };
  },
};
</script>

<style lang="less" scoped>
.richmsg-type-5 {
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  word-wrap: break-word;
  // max-width: 230px;

  ::v-deep img{
    max-width: 100%;
  }
}
/deep/
.emojiText-image {
  height: 20px;
  vertical-align: top;
  min-width: 20px;
  max-width: 20px;
}
</style>
